import React, {useState, useEffect} from "react";
import {Clock} from 'react-analog-time-picker'
import logo from './logo.svg';
import './App.css';


function App() {

  const [value, setValue] = useState(new Date())
  const [selectedTime, setselectedTime] = useState(null)

  const onTimeChange = function(time){
    setselectedTime(time)
  }

  return (
    <div className="App">
    <Clock 
        value={value}
        onTimeChange={onTimeChange}
        digitsColor={'blue'}
        fontsColor={'yellow'}
        backgroundColor={'white'}
    />
    </div>
  );
}

export default App;
